const {
    CONTEXT_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES,
    CONTEXT_COMPLETER_DEMANDE_PIECES_JOINTES,
    CONTEXT_COMPLETER_AJOUT_CERTIFICAT_MEDICAL,
    CONTEXT_MES_DEMARCHES_EN_COURS,
    CONTEXT_MES_AUTORISATIONS,
} = require('constants/apiUrls.constants');
const { combineReducers } = require('redux');
const { APIReducer } = require('store/apiReducer');

const mesDemarchesEtAutorisations = combineReducers({
    mesDemarchesEnCours: APIReducer.bind(null, CONTEXT_MES_DEMARCHES_EN_COURS),
    mesAutorisations: APIReducer.bind(null, CONTEXT_MES_AUTORISATIONS),
    listePiecesManquantesDeclarationArme: APIReducer.bind(
        null,
        CONTEXT_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES,
    ),
    envoyerDemandePjs: APIReducer.bind(null, CONTEXT_COMPLETER_DEMANDE_PIECES_JOINTES),
    envoyerCertificatMedicalPj: APIReducer.bind(null, CONTEXT_COMPLETER_AJOUT_CERTIFICAT_MEDICAL),
});

export default mesDemarchesEtAutorisations;
